import * as yup from 'yup';

const getRequiredMessage = (field: string) => `The ${field} field is required`;
export const generatepdf = yup.object().shape({
    examtype:yup.string().test('select-examtype', getRequiredMessage('examtype'), value => value !== 'default'),
    qty: yup.string().test('select-qty', getRequiredMessage('qty'), value => value !== 'default')
})
